import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LoadingScreen from 'app/pages/shared/LoadingScreen';
import { buildLoginLink } from 'app/utils/lib/routing';

interface Props {
  loginReturnUrl?: string;
}

const RedirectToHome: FC<Props> = props => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(buildLoginLink(props.loginReturnUrl));
  }, [navigate, props.loginReturnUrl]);

  return <LoadingScreen />;
};

export default RedirectToHome;
